import React, { useEffect } from 'react';
import SelectField from '../../../../../FormControl/input/SelectField';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateClassMarkingCompletedType,
  updateGuttmanChartType,
  updateLearningGrowthType
} from '../../../../../../store/actions/class-marking.actions';

const SelectorCompleteType = ({ type = 'student-view' }) => {
  const mode = useSelector((state) => state?.classMarking?.mode || []);
  const completedType = useSelector((state) => {
    switch (type) {
      case 'student-view':
        return state?.classMarking?.completedType;
      case 'guttman-chart':
        return state?.classMarking?.guttmanChartType;
      default:
        return state?.classMarking?.learningGrowthType;
    }
  });

  const dispatch = useDispatch();
  const completedTypeOptions = [
    { value: 'completedTeacher', label: 'Teacher View' },
    { value: 'completedStudent', label: 'Student View' }
  ];
  if (type === 'student-view') {
    completedTypeOptions.unshift({ value: 'general', label: 'General View' });
  }
  return (
    <div className='max-w-150px min-w-100px'>
      <SelectField
        id='completed-type'
        options={completedTypeOptions}
        value={completedType}
        variant='outlined'
        disabled={mode.length > 0}
        onChange={(e) => {
          if (type === 'student-view') {
            dispatch(updateClassMarkingCompletedType(e.target.value));
          } else if (['guttman-chart'].includes(type)) {
            dispatch(updateGuttmanChartType(e.target.value));
          } else {
            dispatch(updateLearningGrowthType(e.target.value));
          }
        }}
      />
    </div>
  );
};

export default SelectorCompleteType;
